import axiosInstanceBuilder from "../config/axios/axiosInstanceBuilder";
import { useFetch } from "../config/axios/useFetch";
import { replacePreTags } from "utils/htmlTransformers";

const baseUrl = process.env.REACT_APP_API_DEV_URL;

export const useUpdateQuestion = (id) => {
  const endpoint = `/questions/${id}`;
  const createAxiosPromise = (data) => {
    return axiosInstanceBuilder(baseUrl).put(endpoint, data);
  };

  const { fetchApi } = useFetch(createAxiosPromise, false);

  const handleUpdateQuestion = async (question) => {
    const updateQuestionRequest = mapQuestionToUpdateRequest(question);
    const response = await fetchApi(updateQuestionRequest);
    const { data, ...rest } = response;
    return { id: data.id, ...rest };
  };

  const mapQuestionToUpdateRequest = ({
    type,
    skill: skill_id,
    difficulty,
    time,
    statement,
    choices,
    resources,
    codeEditors: code_editors,
    allowRunningTestCases: allows_running_test_cases,
    allowedLanguages: coding_languages,
    informsTestCaseCorrectness: informs_test_case_correctness,
    codeMode: solution_code_language,
    solutionCode: solution_code,
    testCases: test_cases,
    outputLinesPerTestCase: output_lines_per_test_case,
    customCodeWrapper: custom_code_wrapper,
  }) => {
    const finalStatement = replacePreTags(statement);

    return {
      type,
      skill_id,
      difficulty,
      time,
      statement: finalStatement,
      choices,
      resources,
      code_editors,
      allows_running_test_cases,
      coding_languages,
      solution_code,
      informs_test_case_correctness,
      solution_code_language,
      test_cases,
      output_lines_per_test_case,
      custom_code_wrapper,
    };
  };

  return { handleUpdateQuestion };
};
